/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_DescriptionInputs */



/**
* | output |
* | --- |
* | "Per integration, choose which tools are offered and to whom. The setting covers every connection of that integration in your organization. Tool restrictions ..." |
*
* @param {Rights_Tools_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_description = /** @type {((inputs?: Rights_Tools_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legen Sie pro Integration fest, welche Tools angeboten werden und für wen. Die Einstellung gilt für jede Verbindung dieser Integration in Ihrer Organisation. Tool-Einschränkungen greifen nur bei der Positur „Nur freigegebene Tools“.")
	return /** @type {LocalizedString} */ ("Per integration, choose which tools are offered and to whom. The setting covers every connection of that integration in your organization. Tool restrictions apply only under the exact-list posture.")
});